import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class InteractivityStageService {
	stageCommandObs: ReplaySubject<any>;

	constructor() {
		this.stageCommandObs = new ReplaySubject(1);
	}

	zoom(direction: 'in' | 'out' | 'toFit') {
		const zoomCommand = {
			method: 'zoom',
			direction
		};
		this.stageCommandObs.next(zoomCommand);
	}

	arrow(direction: 'up' | 'right' | 'down' | 'left', shift = false) {
		const command = {
			method: 'arrow',
			direction,
			shift
		};

		this.stageCommandObs.next(command);
	}
}
